import { useState } from 'react';

// pay.fiscalbusiness.net canlı səhifəsi (iframe). «Yeni pəncərədə aç» düyməsi qəsdən YOXDUR.
export default function PayFrame({ url }) {
    const [loaded, setLoaded] = useState(false);
    return (
        <div className="relative h-full w-full overflow-hidden rounded-2xl border border-gray-200 bg-white">
            {!loaded && (
                <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-white">
                    <div className="h-9 w-9 animate-spin rounded-full border-[3px] border-gray-200 border-t-[#0090bb]" />
                    <span className="text-sm font-medium text-gray-500">Ödəniş səhifəsi açılır</span>
                </div>
            )}
            {url && (
                <iframe
                    title="Ödəniş və abunə"
                    src={url}
                    onLoad={() => setLoaded(true)}
                    allow="payment"
                    referrerPolicy="no-referrer"
                    className="h-full w-full border-0"
                />
            )}
        </div>
    );
}
